import { useEffect, useState } from 'react'

export type TimerAlert = { type: 'stop' | 'end'; id: number } | null

// 计时器到点全屏特效。父组件在触发时递增 id 传入,组件按 id 变化播放一次,播完自动清除。
const TimerAlertFx = ({ alert }: { alert: TimerAlert }) => {
  const [active, setActive] = useState<TimerAlert>(null)

  useEffect(() => {
    if (!alert) return undefined
    setActive(alert)
    const duration = alert.type === 'end' ? 3600 : 1900
    const t = window.setTimeout(() => setActive(null), duration)
    return () => window.clearTimeout(t)
    // 仅按 id 触发,重复同一次 alert 不会重播
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alert?.id])

  if (!active) return null

  if (active.type === 'stop') {
    return (
      <div className="timer-fx-layer" style={{ alignItems: 'flex-start' }}>
        <div className="timer-fx-stop-bg" />
        <div className="timer-fx-stop-badge">⏳ 停止抓牌</div>
      </div>
    )
  }

  return (
    <div className="timer-fx-layer">
      <div className="timer-fx-end-flash" />
      <div className="firework" style={{ left: '24%', top: '34%' }} />
      <div className="firework" style={{ left: '72%', top: '30%', animationDelay: '0.25s' }} />
      <div className="firework" style={{ left: '38%', top: '62%', animationDelay: '0.5s' }} />
      <div className="firework" style={{ left: '64%', top: '66%', animationDelay: '0.75s' }} />
      <div className="timer-fx-end-pop">⏰ 时间到</div>
    </div>
  )
}

export default TimerAlertFx
